module.exports = __webpack_public_path__ + "img/shivam.6eed27fd.png";